import { mapValues, sortBy } from 'lodash';
import React from 'react';
import { useParams } from 'react-router-dom';

import TherigyLoadingSpinner from 'App/components/TherigyLoadingSpinner';
import { NotFound } from 'App/components/errors';
import FlexCenter from 'App/components/styles/FlexCenter';
import CMSService from 'App/services/CMSService';
import useIsPermitted from 'App/utils/hooks/useIsPermitted';
import { PERMISSION_TYPES } from 'App/utils/isPermitted/isPermitted';
import ContentLibraryEditForm from './ContentLibraryEditForm';
import useFetchContentGroup from './hooks/useFetchContentGroup';

const ContentLibraryEditDisplay = () => {
    const { groupUuid } = useParams();
    const { data: contentGroup, isLoading } = useFetchContentGroup(groupUuid);

    if (isLoading) {
        return (
            <FlexCenter style={{ flexGrow: 1 }}>
                <TherigyLoadingSpinner />
            </FlexCenter>
        );
    }

    const sortContentVersions = (cv) => CMSService.labelOrder[contentGroup.type].indexOf(cv.label);
    // TODO: Fix this the next time the file is edited.
    // eslint-disable-next-line react-hooks/immutability
    contentGroup.contentVersions = sortBy(contentGroup.contentVersions, sortContentVersions);
    // TODO: Fix this the next time the file is edited.
    // eslint-disable-next-line react-hooks/immutability
    contentGroup.children = mapValues(contentGroup.children, (child) => ({
        ...child,
        contentVersions: sortBy(child.contentVersions, sortContentVersions),
    }));
    return <ContentLibraryEditForm contentGroup={contentGroup} />;
};

const ContentLibraryEditPage = () => {
    const hasContentLibrary = useIsPermitted(PERMISSION_TYPES.CONTENT_LIBRARY);
    if (!hasContentLibrary) {
        return <NotFound />;
    }
    return <ContentLibraryEditDisplay />;
};

export default ContentLibraryEditPage;
